import CloudCheckmark from 'icons/CloudCheckmark';
import AttributeRow from './AttributeRow';
import ExclamationTriangle from 'icons/ExclamationTriangle';
import { ClaimableEntityType } from 'queries';
import Info from 'icons/Info';
import { useUser } from 'stores/userStore';
import { claimEntity, useUserEntities } from 'stores/userEntitiesStore';
import { findOwnedUserEntity, isOwned, isPending } from 'actions/user_entities_actions';
import { useState } from 'react';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import TextLink, { TextLinkSize } from './TextLink';

function ClaimLink({ entityType, entityId }: { entityType: ClaimableEntityType; entityId: string }) {
  const user = useUser();
  const userEntities = useUserEntities();
  const [, { handleOpenLoginModal }] = useApplicationContainer();
  const [isClaiming, setIsClaiming] = useState(false);

  if (!user.isResolved || (user.isLoggedIn && !userEntities.isResolved)) {
    return null;
  }

  const ownedUserEntity = findOwnedUserEntity(userEntities.userEntities, entityType, entityId);
  const isOwner = !!ownedUserEntity && isOwned(ownedUserEntity);
  const isPendingClaim = !!ownedUserEntity && isPending(ownedUserEntity);

  function handleClick() {
    if (isOwner || isPendingClaim) return;

    if (!user.isLoggedIn) {
      handleOpenLoginModal();
    } else if (!user.canClaim) {
      alert(
        `You must be a coach or an admin to claim a ${entityType}. If you are already logged in as an approved AD, there is no need to claim teams as you already have admin permissions for all teams in your school.`
      );
    } else {
      setIsClaiming(true);
      claimEntity(entityType, entityId);
    }
  }

  return (
    <TextLink size={TextLinkSize.SMALL} onClick={handleClick}>
      {!user.isLoggedIn && 'Login to claim'}
      {isOwner && 'Owned'}
      {(isPendingClaim || isClaiming) && 'Pending'}
      {user.isLoggedIn && !isOwner && !isPendingClaim && !isClaiming && `Claim ${entityType}`}
      <Info height={12} width={12} />
    </TextLink>
  );
}

export default function AttributeRowClaimed({
  isClaimed,
  entityType,
  entityId
}: {
  isClaimed: boolean;
  entityType: ClaimableEntityType;
  entityId: string;
}) {
  return (
    <AttributeRow
      title={
        isClaimed ? (
          <>
            <CloudCheckmark color="#46B760" /> Claimed
          </>
        ) : (
          <>
            <ExclamationTriangle color="#E1464A" /> Unclaimed
          </>
        )
      }
    >
      {!isClaimed && <ClaimLink entityType={entityType} entityId={entityId} />}
    </AttributeRow>
  );
}
